import { combineReducers } from "redux"
import cardReducer from "./cardReducer"
import layoutReducer from "./layoutReducer"

const rootReducer = combineReducers({
    cart: cardReducer,
    layoutReducer
})

export default rootReducer